import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import type { Logger } from '@core/model/domain/logger';
import { loggerToken } from '@di/angularProviderMapper';
import { StoreService } from '@shared/services/store.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-init',
  template: ``,
})
export class InitComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private storeService: StoreService,
    private router: Router,
    @Inject(loggerToken) private logger: Logger
  ) {}

  async ngOnInit(): Promise<void> {
    const { userToken, tagging } = await this.getQueryParams();
    const { userId } = await this.getRouteParams();

    this.logUserRestartedJourney(userId);

    this.storeService.reset();

    this.storeService.setVariable('USER_ID', userId);
    this.storeService.setVariable('OPEN_BANKING_USER_TOKEN', userToken);

    if (tagging) {
      this.storeService.setVariable('TAGGING_INIT_DATA_IN_BASE64', tagging);
    }

    history.replaceState('INIT', '', '/process');
    this.router.navigate(['process']);
  }

  private async getRouteParams(): Promise<{ userId: string }> {
    const { userId } = await firstValueFrom(this.activatedRoute.params);

    if (!userId) {
      throw new Error('Route param userId is missing');
    }

    return { userId };
  }

  private async getQueryParams(): Promise<{
    userToken: string;
    tagging: string | null;
  }> {
    const { tagging, 'user-token': userToken } = await firstValueFrom(this.activatedRoute.queryParams);

    if (!userToken) {
      throw new Error('Query param user-token is missing');
    }

    return {
      userToken,
      tagging,
    };
  }

  private logUserRestartedJourney(queryParamUserId: string) {
    const storedUserId = this.storeService.getVariable('USER_ID');

    if (storedUserId !== null) {
      this.logger.logEvent('USER_RESTARTED_JOURNEY', {
        storedUserId,
        queryParamUserId,
      });
    }
  }
}
